import { render, staticRenderFns } from "./Oral.vue?vue&type=template&id=7d2a4cb7&scoped=true&"
import script from "./Oral.vue?vue&type=script&lang=ts&"
export * from "./Oral.vue?vue&type=script&lang=ts&"
import style0 from "./Oral.vue?vue&type=style&index=0&id=7d2a4cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2a4cb7",
  null
  
)

export default component.exports